<template>
    <v-layout row wrap>
      <v-flex xs12 md12>
          <div class="pie-wrapper">
          <h1 class="top-text">Today</h1>
          <div class="pie" :style='bggradientDay'
              @click="bggradient = bggradientDay,
              wrapper2Text='Today\'s Sales',
              salesOnClick = sales.today,userwiseSales = userwiseSalesDay,
              manualOrderTotal = manualOrderTotalDay,
              onlineOrderTotal = onlineOrderTotalDay,
              pieClicked = 'Day',
              showDetails= true
              "
              :class="pieClicked === 'Day' ? 'pieClicked' : ''"
              >
              <div class="txt">
              <span v-if="!loadingToday"> {{sales.today}}</span>
              <v-layout justify-center align-center v-if="loadingToday">
                  <v-progress-circular
                  indeterminate
                  color="primary">
                  </v-progress-circular>
              </v-layout>
              </div>
          </div>
          </div>
          <div class="pie-wrapper">
          <h1 class="top-text">WTD</h1>
          <div class="pie" :style='bggradientWeek'
              @click="bggradient = bggradientWeek,
              wrapper2Text='WTD Sales',
              salesOnClick = sales.week,
              userwiseSales = userwiseSalesWeek,
              manualOrderTotal = manualOrderTotalWeek,
              onlineOrderTotal = onlineOrderTotalWeek,
              pieClicked = 'Week',
              showDetails= true
          "
          :class="pieClicked === 'Week' ? 'pieClicked' : ''"
          >
              <div class="txt">
              <span v-if="!loadingWeek"> {{sales.week}}</span>
              <v-layout justify-center align-center v-if="loadingWeek">
                  <v-progress-circular
                  indeterminate
                  color="primary">
                  </v-progress-circular>
              </v-layout>
              </div>
          </div>
          </div>
          <div class="pie-wrapper">
          <h1 class="top-text">MTD</h1>
          <div class="pie" :style='bggradientMonth'
              @click="bggradient = bggradientMonth,
              wrapper2Text='MTD Sales',
              salesOnClick = sales.month,
              userwiseSales = userwiseSalesMonth,
              manualOrderTotal = manualOrderTotalMonth,
              onlineOrderTotal = onlineOrderTotalMonth,
              pieClicked = 'Month',
              showDetails= true
          "
          :class="pieClicked === 'Month' ? 'pieClicked' : ''"
          >
              <div class="txt">
              <span v-if="!loadingMonth"> {{sales.month}}</span>
              <v-layout justify-center align-center v-if="loadingMonth">
                  <v-progress-circular
                  indeterminate
                  color="primary">
                  </v-progress-circular>
              </v-layout>
              </div>
          </div>
          </div>
          <div class="pie-wrapper">
          <h1 class="top-text">QTD</h1>
          <div class="pie" :style='bggradientQuarter'
              @click="bggradient = bggradientQuarter,
              wrapper2Text='QTD Sales',
              salesOnClick = sales.quarter,
              userwiseSales = userwiseSalesQuarter,
              manualOrderTotal = manualOrderTotalQuarter,
              onlineOrderTotal = onlineOrderTotalQuarter,
              pieClicked = 'Quarter',
              showDetails= true
          "
          :class="pieClicked === 'Quarter' ? 'pieClicked' : ''"
          >
              <div class="txt">
              <span v-if="!loadingQuarter"> {{sales.quarter}}</span>
              <v-layout justify-center align-center v-if="loadingQuarter">
                  <v-progress-circular
                  indeterminate
                  color="primary">
                  </v-progress-circular>
              </v-layout>
              </div>
          </div>
          </div>
          <div class="pie-wrapper">
          <h1 class="top-text">YTD</h1>
          <div class="pie" :style='bggradientYear'
              @click="bggradient = bggradientYear,
              wrapper2Text='YTD Sales',
              salesOnClick = sales.year,
              userwiseSales = userwiseSalesYear,
              manualOrderTotal = manualOrderTotalYear,
              onlineOrderTotal = onlineOrderTotalYear,
              pieClicked = 'Year',
              showDetails= true
          "
          :class="pieClicked === 'Year' ? 'pieClicked' : ''"
          >
              <div class="txt">
              <span v-if="!loadingYear"> {{sales.year}}</span>
              <v-layout justify-center align-center v-if="loadingYear">
                  <v-progress-circular
                  indeterminate
                  color="primary">
                  </v-progress-circular>
              </v-layout>
              </div>
          </div>
          </div>
      </v-flex>
      <v-flex xs12 md8 m0a v-if="showDetails && $route.name === 'Dashboard'">
        <div class="pie-wrapper2">
          <h1 class="top-text">{{wrapper2Text}}</h1>
          <v-layout row wrap>
            <v-flex xs12 md5 style="text-align: right;" v-if='manualOrderTotal'>
              <div>
                <h1 class="top-text2">Team Breakdown</h1>
              </div>
              <div v-for="(order, user) in this.userwiseSales" v-bind:key="user">
                <h1 class="top-text2">{{order[0]}} - ${{order[1].toLocaleString()}}</h1>
              </div>
            </v-flex>
            <v-flex xs12 md2 v-if="manualOrderTotal">
              <div class="tb"></div>
            </v-flex>
            <v-flex xs12 :class="manualOrderTotal ? 'md5' : 'md12'">
              <div class="pie" :style='bggradient'>
                <div class="txt txt2">
                  <div style="width: 50%;">${{manualOrderTotal}}</div>
                  <div style="width: 50%;">${{onlineOrderTotal}}</div>
                </div>
                <div class="txt txt3">
                  <span v-if="!loadingToday">
                    {{salesOnClick}}
                  </span>
                  <v-layout justify-center align-center v-if="loadingToday">
                    <v-progress-circular
                      indeterminate
                      color="primary">
                    </v-progress-circular>
                  </v-layout>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 md8 m0a v-if="$route.name === 'AccountDashboard'">
        <div class="pie-wrapper3">
          <h1 class="top-text">Outstanding Balances</h1>
          <v-layout row wrap>
            <v-flex xs12 class="md12">
              <div class="pie" style="background-image: conic-gradient(#565e6f 50%, #565e6f 50%);">
                <div class="txt txt2">
                </div>
                <div class="txt">
                  <span>
                    ${{outStandingSales}}
                  </span>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
</template>

<script>
import OrderService from '@/services/OrderService'
export default {
  props: {
    outStandingSales: String
  },
  data: () => ({
    loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
    showDetails: false,
    fcEvents: [],
    value: [],
    ordersImport: '',
    span: 7,
    sales: {
      today: '$0',
      week: '$0',
      month: '$0',
      quarter: '$0',
      year: '$0'
    },
    pieClicked: '',
    salesOnClick: '',
    wrapper2Text: 'Today\'s Sales',
    orderDetails: [],
    userwiseSales: {},
    userwiseSalesDay: {},
    userwiseSalesWeek: {},
    userwiseSalesMonth: {},
    userwiseSalesQuarter: {},
    userwiseSalesYear: {},
    loadingToday: true,
    loadingWeek: true,
    loadingQuarter: true,
    loadingMonth: true,
    loadingYear: true,
    loadingOrderOverview: true,
    notToShowStatuses: [null, 'Need to Book Check Measure', 'Cart', 'Pending'],
    onlineOrderTotalDay: 0,
    manualOrderTotalDay: 0,
    onlineOrderTotalWeek: 0,
    manualOrderTotalWeek: 0,
    onlineOrderTotalMonth: 0,
    manualOrderTotalMonth: 0,
    onlineOrderTotalQuarter: 0,
    manualOrderTotalQuarter: 0,
    onlineOrderTotalYear: 0,
    manualOrderTotalYear: 0,
    onlineOrderTotal: 0,
    manualOrderTotal: 0,
    bggradient: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    bggradientDay: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    bggradientWeek: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    bggradientQuarter: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    bggradientMonth: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    bggradientYear: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    showDashboard: true
  }),
  computed: {
    filteredOrderDetails () {
      return this.orderDetails.filter(o => !(this.notToShowStatuses.indexOf(o._id) > -1))
    }
  },
  async mounted () {
    this.getSalesDataToday()
    this.getSalesDataWeek()
    this.getSalesDataMonth()
    this.getSalesDataQuarter()
    this.getSalesDataYear()
    await this.getOrderOverview()
  },
  methods: {
    sendToLink (status) {
      if (status === 'Quote') {
        this.$router.push('/quotes')
      } else {
        this.$cookies.set('enabled-statuses', status)
        this.$router.push('/orders')
      }
    },
    getCurrentMonthYear () {
      var today = new Date()
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      return months[today.getMonth()] + ' ' + today.getFullYear()
    },
    async getXDays (span) {
      while (span > 0) {
        let daysOrders = await this.getOrdersOnDay(span - 1)
        this.value.push(daysOrders)
        span--
      }
    },

    async getOrdersOnDay (offset) {
      // Using the offset subtract a days worth of miliseconds off todays date
      var day = new Date(new Date().getTime() - (offset * (86400 * 1000))).toDateString()
      const orderResponse = await OrderService.getOrdersOnDay(day)
      console.log(orderResponse.data)
      return orderResponse.data.orders.length
    },

    async getSalesDataToday () {
      let todayResponse = await OrderService.getTodayTotal()
      if (todayResponse.data.todayTotal !== 0) {
        this.sales.today = '$' + parseFloat(todayResponse.data.todayTotal.toFixed(2)).toLocaleString()
      } else {
        this.sales.today = '$0'
      }
      this.salesOnClick = this.sales.today
      this.calculatePerc(todayResponse.data.orders, 'today')
      this.loadingToday = false
    },
    async getSalesDataWeek () {
      let weekResponse = await OrderService.getWeekTotal()
      if (weekResponse.data.weekTotal !== 0) {
        this.sales.week = '$' + parseFloat(weekResponse.data.weekTotal.toFixed(2)).toLocaleString()
      } else {
        this.sales.week = '$0'
      }
      this.calculatePerc(weekResponse.data.orders, 'week')
      this.loadingWeek = false
    },
    async getSalesDataMonth () {
      let monthResponse = await OrderService.getMonthTotal()
      if (monthResponse.data.monthTotal !== 0) {
        this.sales.month = '$' + parseFloat(monthResponse.data.monthTotal.toFixed(2)).toLocaleString()
      } else {
        this.sales.month = '$0'
      }
      this.calculatePerc(monthResponse.data.orders, 'month')
      this.loadingMonth = false
    },
    async getSalesDataQuarter () {
      let quarterResponse = await OrderService.getQuarterTotal()
      if (quarterResponse.data.quarterTotal !== 0) {
        this.sales.quarter = '$' + parseFloat(quarterResponse.data.quarterTotal.toFixed(2)).toLocaleString()
      } else {
        this.sales.quarter = '$0'
      }
      this.calculatePerc(quarterResponse.data.orders, 'quarter')
      this.loadingQuarter = false
    },
    async getSalesDataYear () {
      let yearResponse = await OrderService.getYearTotal()
      if (yearResponse.data.yearTotal !== 0) {
        this.sales.year = '$' + parseFloat(yearResponse.data.yearTotal.toFixed(2)).toLocaleString()
      } else {
        this.sales.year = '$0'
      }
      this.calculatePerc(yearResponse.data.orders, 'year')
      this.loadingYear = false
    },
    async getOrderOverview () {
      let orderCountByStatus = await OrderService.orderCountByStatus()
      this.orderDetails = orderCountByStatus.data.ordersByStatus
      this.loadingOrderOverview = false
      // this.orderDetails = [
      //   {key: 'PENDING', value: 1},
      //   {key: 'PROCESSING', value: 2},
      //   {key: 'AWAITING CHECK MEASURE', value: 3},
      //   {key: 'SENT TO FACTORY', value: 4},
      //   {key: 'COMPLETED BY FACTORY', value: 5},
      //   {key: 'SENT TO CUSTOMER', value: 5},
      //   {key: 'QUOTE', value: 5},
      //   {key: 'ARCHIVED', value: 5},
      //   {key: 'NEED TO BOOK CHECK MEASURE', value: 5},
      //   {key: 'NEED TO BOOK INSTALL', value: 5},
      // ]
    },
    // async temp () {
    //   this.ordersImport = await OrderService.ordersImport()
    // },
    async calculatePerc (orders, dataOf) {
      let onlineOrders = orders.filter(function (order) {
        return !order.createdBy && !order.updatedBy
      })
      let manualOrders = orders.filter(function (order) {
        return order.createdBy || order.updatedBy
      })
      let manualOrderTotal = 0
      let onlineOrderTotal = 0
      let totalSales = 0
      let userwiseSales = {}
      for (let index = 0; index < manualOrders.length; index++) {
        const order = manualOrders[index]

        let salesPerson = ''
        if (order.updatedBy) {
          salesPerson = order.updatedBy.firstName
        } else {
          salesPerson = order.createdBy.firstName
        }

        let orderTotal = order.subTotal
        if (order.shipping != null) {
          orderTotal += order.shipping
        }
        if (order.insurance != null) {
          orderTotal += order.insurance
        }
        if (order.install != null) {
          orderTotal += order.install
        }
        if (order.measure != null) {
          orderTotal += order.measure
        }
        if (order.discount != null) {
          orderTotal -= order.discount
        }

        if (this.loggedInUser.position && this.loggedInUser.position.role === 'manager') {
          if (userwiseSales[salesPerson]) {
            userwiseSales[salesPerson] += orderTotal
          } else {
            userwiseSales[salesPerson] = orderTotal
          }
        } else {
          if (salesPerson === this.loggedInUser.firstName) {
            if (userwiseSales[salesPerson]) {
              userwiseSales[salesPerson] += orderTotal
            } else {
              userwiseSales[salesPerson] = orderTotal
            }
          }
        }
        manualOrderTotal += orderTotal
      }
      var sortable = []
      var maxData = userwiseSales
      for (var value in maxData) {
        sortable.push([value, maxData[value]])
      }
      sortable.sort(function (a, b) {
        return b[1] - a[1]
      })
      userwiseSales = sortable
      for (let index = 0; index < onlineOrders.length; index++) {
        const order = onlineOrders[index]
        let orderTotal = order.subTotal
        if (order.shipping != null) {
          orderTotal += order.shipping
        }
        if (order.insurance != null) {
          orderTotal += order.insurance
        }
        if (order.install != null) {
          orderTotal += order.install
        }
        if (order.measure != null) {
          orderTotal += order.measure
        }
        if (order.discount != null) {
          orderTotal -= order.discount
        }
        onlineOrderTotal += orderTotal
      }
      totalSales = onlineOrderTotal + manualOrderTotal
      // totalSales = totalSales.toLocaleString()
      // onlineOrderTotal = onlineOrderTotal.toLocaleString()
      // manualOrderTotal = manualOrderTotal.toLocaleString()
      let firstColor = onlineOrderTotal / totalSales * 100
      let secondColor = 100 - firstColor
      secondColor = 0.1 // second color will be auto set
      if (dataOf === 'today') {
        this.bggradientDay = `background-image: conic-gradient(#565e6f ${firstColor}%, #ea4d76 ${secondColor}%)`
        if (firstColor === 0) {
          this.bggradientDay = `background-image: conic-gradient(#ea4d76 ${firstColor}%, #ea4d76 ${secondColor}%)`
        } else if (secondColor === 0) {
          this.bggradientDay = `background-image: conic-gradient(#565e6f ${firstColor}%, #565e6f ${secondColor}%)`
        }
        // this.bggradient = this.bggradientDay
        this.userwiseSalesDay = userwiseSales
        this.onlineOrderTotalDay = onlineOrderTotal.toLocaleString()
        this.manualOrderTotalDay = manualOrderTotal.toLocaleString()
        // this.onlineOrderTotal = onlineOrderTotal.toLocaleString()
        // this.manualOrderTotal = manualOrderTotal.toLocaleString()
        // this.userwiseSales = userwiseSales
      } else if (dataOf === 'week') {
        this.bggradientWeek = `background-image: conic-gradient(#565e6f ${firstColor}%, #ea4d76 ${secondColor}%)`
        if (firstColor === 0) {
          this.bggradientWeek = `background-image: conic-gradient(#ea4d76 ${firstColor}%, #ea4d76 ${secondColor}%)`
        } else if (secondColor === 0) {
          this.bggradientWeek = `background-image: conic-gradient(#565e6f ${firstColor}%, #565e6f ${secondColor}%)`
        }
        this.userwiseSalesWeek = userwiseSales
        this.onlineOrderTotalWeek = onlineOrderTotal.toLocaleString()
        this.manualOrderTotalWeek = manualOrderTotal.toLocaleString()
      } else if (dataOf === 'month') {
        this.bggradientMonth = `background-image: conic-gradient(#565e6f ${firstColor}%, #ea4d76 ${secondColor}%)`
        if (firstColor === 0) {
          this.bggradientMonth = `background-image: conic-gradient(#ea4d76 ${firstColor}%, #ea4d76 ${secondColor}%)`
        } else if (secondColor === 0) {
          this.bggradientMonth = `background-image: conic-gradient(#565e6f ${firstColor}%, #565e6f ${secondColor}%)`
        }
        this.userwiseSalesMonth = userwiseSales
        this.onlineOrderTotalMonth = onlineOrderTotal.toLocaleString()
        this.manualOrderTotalMonth = manualOrderTotal.toLocaleString()
      } else if (dataOf === 'quarter') {
        this.bggradientQuarter = `background-image: conic-gradient(#565e6f ${firstColor}%, #ea4d76 ${secondColor}%)`
        if (firstColor === 0) {
          this.bggradientQuarter = `background-image: conic-gradient(#ea4d76 ${firstColor}%, #ea4d76 ${secondColor}%)`
        } else if (secondColor === 0) {
          this.bggradientQuarter = `background-image: conic-gradient(#565e6f ${firstColor}%, #565e6f ${secondColor}%)`
        }
        this.userwiseSalesQuarter = userwiseSales
        this.onlineOrderTotalQuarter = onlineOrderTotal.toLocaleString()
        this.manualOrderTotalQuarter = manualOrderTotal.toLocaleString()
      } else if (dataOf === 'year') {
        this.bggradientYear = `background-image: conic-gradient(#565e6f ${firstColor}%, #ea4d76 ${secondColor}%)`
        if (firstColor === 0) {
          this.bggradientYear = `background-image: conic-gradient(#ea4d76 ${firstColor}%, #ea4d76 ${secondColor}%)`
        } else if (secondColor === 0) {
          this.bggradientYear = `background-image: conic-gradient(#565e6f ${firstColor}%, #565e6f ${secondColor}%)`
        }
        this.userwiseSalesYear = userwiseSales
        this.onlineOrderTotalYear = onlineOrderTotal.toLocaleString()
        this.manualOrderTotalYear = manualOrderTotal.toLocaleString()
      }
      // //
    }
  },
  components: {
  }
}
</script>

<style scoped>
.link {
  cursor: pointer;
}
.link:hover {
  opacity: 0.7
}
.event-box {
    padding: 25px;
}
.m0a {
  margin: 0 auto;
}
.pie-wrapper {
  width: 20%;
  float: left;
}
.pie {
  width: 250px;
  height: 250px;
  max-width: 100%;
  max-height: 100%;
  background-image: conic-gradient(#ea4d76 50%, #565e6f 50%);
  border-radius: 50%;
  position: relative;
  margin: 0 auto;
  cursor: pointer;
}
.pieClicked {
  border: 5px green solid;
  background: #fff;
  background-image: none !important;
}
.pieClicked .txt {
  color: green !important;
}
.pie-wrapper2 .pie {
  width: 350px;
  height: 350px;
}
.pie .txt {
  position: absolute;
  color: #fff;
  font-size: 32px;
  font-weight: bold;
  width: 100px;
  text-align: center;
  width: 100%;
  top: 40%;
}
.pie .txt2 {
  top: 45%;
  font-size: 26px;
}
.pie .txt3 {
  top: 10%;
}
.pie .txt2 > div {
  float: left;
}
.top-text {
  text-align: center;
  color: #ea4d76;
  margin: 20px;
}
.top-text2 {
  color: #565e6f;
  margin-bottom: 20px;
}
.tb {
  content: '';
  border-bottom: 4px solid #ea4d76;
  height: 175px;
  width: calc(100% - 60px);
  margin-left: 30px;
}
@media screen and (max-width: 661px) {
  .pie-wrapper {
    width: 100%;
    float: left;
  }
  .top-text2 {
    text-align: center;
  }
  .tb {
    height: 25px;
    border-right: 4px solid #ea4d76;
    margin: 0 auto;
    width: 4px;
    border-bottom: none;
  }
  .pie-wrapper2 .pie[data-v-aae30ed8] {
    max-width: 290px;
    max-height: 290px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardSales.vue